/**
 * Clock icon for outbound messages still queued in the OncoEMR send outbox.
 */

/** Props for {@link TaskMessagePendingIcon}. */
interface TaskMessagePendingIconProps {
  className?: string;
  width?: number;
  height?: number;
}

/**
 * Renders a clock icon indicating a message is pending delivery.
 *
 * @param props - Optional class name and dimensions for the SVG.
 * @returns Clock SVG for pending outbox rows.
 */
const TaskMessagePendingIcon = ({
  className,
  width = 24,
  height = 24,
}: TaskMessagePendingIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <circle cx="10" cy="10" r="7.5" stroke="#6B6B6B" strokeWidth="1.5" />
    <path
      d="M10 6V10L12.5 12"
      stroke="#6B6B6B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TaskMessagePendingIcon;
